import React, { useState, useEffect } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link, useParams } from "react-router-dom";

const ComparisionView = () => {
    useAuthRedirect();
    const {itemCode} = useParams();
const [data, setData] = useState([]);
const branch = localStorage.getItem("branch");
const [filteredData, setFilteredData] = useState([]);
const [searchTerm, setSearchTerm] = useState("");
const [currentPage, setCurrentPage] = useState(1);
const [itemsPerPage] = useState(10);
const [loading, setLoading] = useState(false);

const canView  = hasPermission("Rate comparision", "view");

useEffect(() => {
    fetchData();
}, [branch, itemCode]);

const fetchData = async () => {
    setLoading(true);
    try {
    const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemView_detail?branch=${branch}&itemCode=${itemCode}`);
    setData(response.data.BOlist);
    setFilteredData(response.data.BOlist);
    } catch (error) {
    console.error("Error fetching BOlist:", error);
    } finally {
    setLoading(false);
    }
};

const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
        setFilteredData(data);
        return;
    }

    const filtered = data.filter((item) => 
        String(item.supplierWIdetail_code || "").toLowerCase().includes(term) || 
        String(item.itemmaster_name || "").toLowerCase().includes(term)
    );

    setFilteredData(filtered);
};

 if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


// Pagination
const paginate = (pageNumber) => setCurrentPage(pageNumber);
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

return (
    <div id="admin-container">
    <InventoryNav />
    <div className="content-right">
        <section>
         <div className="back-div">
                  <h2 className="add-txt">Supplier With Item - View</h2>
                  <Link to='/inventory/itemMasterViewcomparision'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                  </div>
        <Time />
        </section>

        {/* Search Filter */}
        <div className="search-filter">
        <p>Search: </p>
        <input
            type="text"
            placeholder="Search by Supplier & Item Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
        />
        </div>

        {/* Table */}
        <div className="content-table">
        <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Supplier Code</th>
                <th>Item Name</th>
                <th>UOM</th>
                <th>Price</th>
                <th>Tax%</th>
                <th>P&F%</th>
                <th>Disc%</th>
                <th>Net Amount</th>
            </tr>
            </thead>
            <tbody>
            {loading ? (
                <tr>
                <td colSpan="6" className="loading-text">Loading data, please wait...</td>
                </tr>
            ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    {/* <td>
                    <Link to={`/inventory/addNewSupplierWithItem/${item.supplierWIdetail_code}`}>
                        {item.supplierWIdetail_code}
                    </Link>
                    </td> */}
                      <td>{item.supplierWIdetail_code}</td>
                    <td>{item.itemmaster_name}</td>
                    <td>{item.itemMaster_purchaseUom}</td>
                    <td>{item.supplierWIdetail_price}</td>
                    <td>{item.SupplierWIDetail_CSTtax}</td>
                    <td>{item.supplierWIdetail_PfPercentage}</td>
                    <td>{item.supplierWIdetail_discountPercentage}</td>
                    <td>{item.SupplierWIDetail_netamount}</td>
                </tr>
                ))
            ) : (
                <tr>
                <td colSpan="6">No Data Available</td>
                </tr>
            )}
            </tbody>
        </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
        </button>

        {/* Always show first page */}
        <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>
            1
        </button>

        {/* Show up to 3 pages dynamically */}
        {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
            const pageNumber = currentPage + index;
            if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                </button>
                );
            }
            return null;
            })
        }

        {/* Next button */}
        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
            Next
        </button>
        </div>
    </div>
    </div>
);
};

export default ComparisionView;
